import React, { memo } from 'react';
import PermissionsView from './PermissionsView';

interface Step5Props {
  formData: {
    consent: boolean;
  };
  consentError?: boolean;
  onHandleConsent: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Step5: React.FC<Step5Props> = ({
  formData,
  onHandleConsent,
  consentError,
}) => {
  return (
    <>
      <div>
        {/* Permissions Intro */}
        <div className="flex justify-start gap-2 mb-5 mx-auto w-[85%]">
          <div
            className="mr-5 w-[200px]"
            dangerouslySetInnerHTML={{
              __html: `<div style="position: relative; box-sizing: content-box; width: 100%; aspect-ratio: 1.7777777777777777;"><iframe src="https://guides.shipaid.com/embed/cmcwg6d1r1ghx9emp1g094zi9?embed_v=2" loading="lazy" title="Grant Secure Access to Finalize Setup" allow="clipboard-write" frameborder="0" webkitallowfullscreen="true" mozallowfullscreen="true" allowfullscreen style="width: 200px; height: 150px"></iframe></div>`,
            }}
          />
          <div className="text-left">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Grant Collaborator Access to Finalize Setup
            </h2>
            <p className="text-gray-600 mb-8">
              Secure access lets us complete your expert setup and deliver the
              best experience for you and your customers.
            </p>
          </div>
        </div>

        <PermissionsView />

        {/* Consent Checkbox */}
        <div className="flex items-center my-5 justify-end">
          <input
            type="checkbox"
            id="permissions"
            checked={formData.consent}
            onChange={onHandleConsent}
            className={`h-4 w-4 text-[${
              consentError ? '#b91c1c' : '#2563eb'
            }] focus:ring-[${consentError ? '#b91c1c' : '#2563eb'}] rounded`}
          />
          <label
            htmlFor="permissions"
            className={`ml-2 text-sm ${
              consentError ? 'text-red-700' : 'text-gray-700'
            }`}
          >
            I understand and agree to the required permissions
          </label>
        </div>
      </div>
    </>
  );
};

export default memo(Step5);
